import React, { useEffect, useMemo, useState } from "react";
import CustomReceiptForm from "./CustomReceiptForm";
import BusReceiptForm from "./BusReceiptForm";

export default function CustomParentReceipt({report,values,link}) {
  const [students, setStudents] = useState([]);
  const [duration, setDuration] = useState(1);
  const [selectedStudent, setSelectedStudent] = useState(null);


  useEffect(() => {
    
    // const studentsData =
    //     report?.map((d) => d);

    //   const studentsList = Array.isArray(studentsData?.table)
    //     ? studentsData.table
    //     : studentsData?.fields
    //       ? [studentsData.fields]
    //       : [];

      
    //   // add UI-only state
      setStudents(
        report.map((s) => ({
          ...s,
          selected: false,
        }))
      );

    
  }, []);

  console.log("link of sponser: ",link)
  const columns = useMemo(() => {
    if (!students.length) return [];
    return Object.keys(students[0]).filter(
      (k) => k !== "selected"
    );
  }, [students]);

  const amountKey = useMemo(() => {
  if (!students.length) return null;

  return Object.keys(students[0]).find(
    (k) =>
      k.toLowerCase() === "amount"
  );
}, [students]);



  const total = useMemo(() => {
  if (!amountKey) return 0;

  return students
    .filter((s) => s.selected)
    .reduce(
      (sum, s) =>
        sum + Number(s[amountKey] || 0) * duration,
      0
    );
}, [students, duration, amountKey]);

  /* ---------- RENDER ---------- */

  return (
    <div className="container-fluid mt-3">
      {/* SPONSOR */}
      {/* <div className="mb-3">
        <label className="fw-semibold mb-1">Sponsor</label>
        <div className="d-flex gap-2">
          <input
            className="form-control"
            value={sponsor.sponsor || ""}
            readOnly
          />
          <button className="btn btn-primary px-4">
            Print
          </button>
        </div>
      </div> */}

      {/* STUDENTS TABLE */}
      <div className="table-responsive">
        <table className="table table-bordered align-middle">
          <thead className="table-light">
            <tr>
              {columns.map((col) => (
                <th key={col}>{col.toUpperCase()}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {students.map((row, rowIndex) => (
              <tr key={row.id || rowIndex}>
                {columns.map((col) => (
                 <td key={col}>
  {col === "ID" ? (
    <>
      <input
        type="checkbox"
        className="form-check-input me-1"
        checked={row.selected}
        onChange={() =>
          setStudents((prev) =>
            prev.map((r, i) =>
              i === rowIndex
                ? { ...r, selected: !r.selected }
                : r
            )
          )
        }
      />
      {row[col]}
    </>
  ) : col === "Student Name" ? (
    <span
      className="text-primary"
      style={{ cursor: "pointer" }}
      onClick={() => setSelectedStudent(row)}
    >
      {row[col]}
    </span>
  ) : col === "Amount" ? (
    Number(row[col]).toFixed(2)
  ) : (
    row[col]
  )}
</td>

                ))}
              </tr>
            ))}
          </tbody>
        </table>
        
      </div>

      {/* SUMMARY */}
      <div className="d-flex justify-content-end mt-3 fw-semibold">
        Wadarta Guud &nbsp; ${total.toFixed(2)}
      </div>

      {/* FOOTER */}
      <div className="d-flex justify-content-center gap-4 mt-3">
        <div>
          <label className="me-2">Duration</label>
          <input
            type="number"
            min="1"
            className="form-control d-inline-block"
            style={{ width: 80 }}
            value={duration}
            onChange={(e) =>
              setDuration(Number(e.target.value))
            }
          />
        </div>

        <div>
          <label className="me-2">Total</label>
          <input
            className="form-control d-inline-block"
            style={{ width: 120 }}
            value={total.toFixed(2)}
            disabled
          />
        </div>
        
      </div>
      {selectedStudent && (
        (link.route==='sponser-report' || link.route==='scholarship-students-report' )?
  <CustomReceiptForm
    std_id={selectedStudent.ID || selectedStudent.id}
    fee_id={522} 
    route={link.route}
  /> 
  : <BusReceiptForm
    std_id={selectedStudent.ID || selectedStudent.id}
    fee_id={557} 
    route={link.route}
  />
)}

    </div>
  );
}
